import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Image } from 'react-bootstrap';
import Stack from 'react-bootstrap/Stack';
// import { useState } from 'react';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';

function About () {
    
    // const [show, setShow] = useState(false);

    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);
    
    return (


        <section id="about" className='block about-block'>
            <Container fluid>
                <div className='title-holder'>
                    <h2>About Me</h2>
                </div>
                <div>
                    <Row>
                        <Col md={4}>
                            <div className='about-me'>
                                <Image id="about-image" src={require("../assets/images/snap.jpg")} />
                            </div>
                        </Col>
                        <Col md={8}>
                            <div className='about-me'>
                                <h3>CS Student | Aspiring FS Dev x Cybersec</h3>
                                <p className='about-me-subtitle'>
                                    Hello! I am John Rey S. Tolosa, an aspiring Full Stack Developer and Cybersecurity analyst.  
                                </p>
                                <Stack direction="horizontal" gap={5}>
                                    <div className="p-2">
                                        <p className="inline-p" id='inline-p'>• Address:</p>
                                        <p className="inline-p">Cararayan, Naga City, 4400</p>
                                    </div>
                                    <div className="p-2">
                                        <p className="inline-p" id='inline-p'>• Current School:</p>
                                        <p className="inline-p">Naga College Foundation</p>
                                    </div>
                                </Stack>
                                <Stack direction="horizontal" gap={5}>
                                    <div className="p-2">
                                        <p className="inline-p" id='inline-p'>• Phone Number: </p>
                                        <p className="inline-p">(+63)909-442-2259</p>
                                    </div>
                                    <div className="p-2">
                                        <p className="inline-p" id='inline-p'>• College Level:</p>
                                        <p className="inline-p">3rd year college</p>
                                    </div>
                                </Stack>
                                <p>
                                I gained an interest in computers as early as my elementary days. A simple glimpse and click on those CRT (Cathode Ray Tube) monitors and noisy membrane keyboards sparked my endless seeking of knowledge, a power of curiosity indeed. 
                                </p>
                                <p>
                                    Aside from being technology enthusiast, I am also interested in other aspects. Below are some of my interests, and some are hobby also.
                                </p>
                                <Stack direction="horizontal" gap={5}>
                                    <Container className="interests">
                                        <Col md={4} className="icon">
                                            <Image className="draw-icon" src={require("../assets/images/edit.png")} />
                                        </Col>
                                        <Col md={4} className="icon">
                                            <p className='interest-title'>Drawing</p>
                                        </Col>
                                    </Container>
                                    <Container className="interests">
                                        <Col md={4} className="icon">
                                            <Image className="draw-icon" src={require("../assets/images/fireship.png")} />
                                        </Col>
                                        <Col md={4} className="icon">
                                            <p className='interest-title'>Fireship</p>
                                        </Col>
                                    </Container>
                                    <Container className="interests">
                                    <Col md={4} className="icon">
                                            <Image className="draw-icon" src={require("../assets/images/spotify.png")} />
                                        </Col>
                                        <Col md={4} className="icon">
                                            <p className='interest-title'>Music</p>
                                        </Col>
                                    </Container>
                                    <Container className="interests">
                                    <Col md={4} className="icon">
                                            <Image className="draw-icon" src={require("../assets/images/gamer.png")} />
                                        </Col>
                                        <Col md={4} className="icon">
                                            <p className='interest-title'>Gaming</p>
                                        </Col>
                                    </Container>
                                </Stack>
                                <p></p>
                                <Stack direction="horizontal" gap={5}>
                                    <Container className="interests">
                                        <Col md={4} className="icon">
                                            <Image className="draw-icon" src={require("../assets/images/ride.png")} />
                                        </Col>
                                        <Col md={4} className="icon">
                                            <p className='interest-title'>Driving</p>
                                        </Col>
                                    </Container>
                                    <Container className="interests">
                                        <Col md={4} className="icon">
                                            <Image className="draw-icon" src={require("../assets/images/motorcycle.png")} />
                                        </Col>
                                        <Col md={4} className="icon">
                                            <p className='interest-title'>Motor</p>
                                        </Col>
                                    </Container>
                                    <Container className="interests">
                                    <Col md={4} className="icon">
                                            <Image className="draw-icon" src={require("../assets/images/cars.png")} />
                                        </Col>
                                        <Col md={4} className="icon">
                                            <p className='interest-title'>Cars</p>
                                        </Col>
                                    </Container>
                                    <Container className="interests">
                                    <Col md={4} className="icon">
                                            <Image className="draw-icon" src={require("../assets/images/keyboard.png")} />
                                        </Col>
                                        <Col md={4} className="icon">
                                            <p className='interest-title'>Keebs</p>
                                        </Col>
                                    </Container>
                                </Stack>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )
}

export default About;